import { gql } from '@apollo/client';

export const GET_LEAGUE_SCHEDULE_DETAILS = gql`
  query LeagueScheduleDetails($leagueId: ID!, $input: GameFilterInput) {
    league(_id: $leagueId) {
      _id
      max_dropins_per_game
      weeks {
        _id
        week_num
        games(input: $input) {
          _id
          start_time
          rsvped {
            teamId
            response
            isDropin
          }
          teams {
            _id
            color {
              name
              hex
            }
            name
          }
        }
      }
    }
  }
`;

export const GET_TEAM_RSVPS = gql`
  query getTeamRSVPs($input: TeamRsvpStatusInput!) {
    teamRsvpStatus(input: $input) {
      teamRsvps {
        _id
        response
        isDropin
      }
    }
  }
`;

export const GET_DROPINS_FOR_GAME_AND_TEAM = gql`
  query getDropinsForGameAndTeam($gameId: ID!, $teamId: ID!) {
    dropInSlotsByGameAndTeam(gameId: $gameId, teamId: $teamId) {
      _id
      closedAt
      closedBy
      rsvpId
    }
  }
`;

export const OPEN_DROPIN_SLOT = gql`
  mutation openDropInSlot($input: OpenDropInSlotInput!) {
    openDropInSlot(input: $input) {
      _id
      gender
    }
  }
`;

export const REMOVE_REGISTRANT_FROM_DROPIN = gql`
  mutation removeRegistrantFromDropin($input: RemoveRegistrantFromDropinInput!) {
    removeRegistrantFromDropin(input: $input) {
      dropInSlotId
      playerName
    }
  }
`;

export const ADD_PLAYER_TO_DROPIN = gql`
  mutation addPlayerToDropin($input: AddPlayerToDropinInput!) {
    addPlayerToDropin(input: $input) {
      registrant {
        _id
      }
      dropInSlotId
    }
  }
`;
